import { AiLegalMapResult } from './legal-map.models';

/** Names and payloads together so they cannot drift; `as const` makes a mistyped name a compile error. */
export const AiLegalMapEvents = {
  progressed: 'ai-legal-map.progressed',
  completed: 'ai-legal-map.completed',
  failed: 'ai-legal-map.failed',
  cancelled: 'ai-legal-map.cancelled'
} as const;

export type AiLegalMapEventType = (typeof AiLegalMapEvents)[keyof typeof AiLegalMapEvents];

/** Every event identifies its run, so a stale or cancelled run's late events can be discarded. */
export interface AiLegalMapRunPayload {
  runId: string;
  projectId: string;
}

export interface AiLegalMapProgressedPayload extends AiLegalMapRunPayload {
  phase: string;
  message: string;
  percent: number;
  elapsedMs: number;
}

/** Proposals ride the event - the run's snapshot is best-effort and can be lost. */
export interface AiLegalMapCompletedPayload extends AiLegalMapRunPayload {
  summary: string;
  result: AiLegalMapResult | null;
}

/** The reason is carried here because the user is expected to act on it, so it is shown as-is. */
export interface AiLegalMapFailedPayload extends AiLegalMapRunPayload {
  message: string;
}

/** A cancel is the user's own doing - distinct from a failure so it raises no error. */
export type AiLegalMapCancelledPayload = AiLegalMapRunPayload;

/** The set this feature owns - one realtime stream carries every feature's events. */
export const AI_LEGAL_MAP_EVENT_TYPES: readonly AiLegalMapEventType[] = Object.values(AiLegalMapEvents);
